import styled from 'styled-components'
import { Carousel } from 'react-bootstrap'
import { theme } from './../../common'

export const StyledCarouselItem = styled(Carousel.Item)`
    position: relative;
    background-color: #ccc;
    img {
        width: 100%;
        height: auto;
    }
    max-height: 80vh;
`

export const ItemContainer = styled.div`
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    left: 10%;

    h2 {
        font-size: 4.5em;
        font-weight: bold;
    }

    p {
        font-size: 1.3em;
    }

    max-width: 30%;

    @media screen and (max-width: 1200px) {
        max-width: 35%;
        h2 {
            font-size: 3em;
            text-transform: uppercase;
        }

        p {
            font-size: 1.2em;
        }
     }

     @media screen and (max-width: 992px) {
         max-width: 50%;
         h2 {
             font-size: 2.7em;
         }

         p {
             font-size: 1em;
         }
     }

     @media screen and (max-width: 768px) {
         max-width: 70%;
         h2 {
             font-size: 2em;
         }

         p {
             font-size: .9em;
         }
     }

     @media screen and (max-width: 576px) {
         h2 {
             font-size: 1.5em;
         }
         p{
             display: none;
         }
     }
`

export const CarouselWrapper = styled.div`
    position: relative;
    ${({margin}) => margin && `margin: ${margin}`}
`

export const StyledIndicatorsList = styled.ol`
    margin: 0px;
    padding: 0px;
    &.carousel-indicators {
        li {
            background-color: ${theme.white};
            width: 10px;
            height: 10px;
            border-radius: 100%;
            &.active {
                background-color: ${theme.green};
            }
        }
    }
`
export const StyledIndicatorsItem = styled.li``
